import { createContext } from 'react';

export const CreationFundContext = createContext(null);
